import { useEffect } from 'react';
import { useAppDispatch } from './Redux/store';
import { fetchMe } from './Redux/Slices/authSlice';
import { useResolvedTheme } from './Hooks/useTheme';
import AppRoutes from './Routes';

export default function App() {
  const dispatch = useAppDispatch();
  const theme = useResolvedTheme();

  // Restore the session on first paint so a refresh does not bounce to /login.
  useEffect(() => {
    void dispatch(fetchMe());
  }, [dispatch]);

  /**
   * One place applies the theme. `useResolvedTheme` owns the `system`
   * subscription, so an OS that flips at sunset repaints a console that is
   * already open, not only one that is next reloaded.
   */
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    // Lets the browser paint native widgets to match; without it a dark page
    // keeps a white <select> popup and light scrollbars.
    document.documentElement.style.colorScheme = theme;
  }, [theme]);

  return <AppRoutes />;
}
